import styled from 'styled-components';

export const FieldsWrapper = styled.div`
  width: 100%;

  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;
